import { Close } from "@mui/icons-material";
import { Avatar, Grid2, IconButton, TextField, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { IOrder } from "sierra";
import Container from "../../../../components/Container";
import { useApp } from "../../../../contexts/AppContext";

export default function CustomerProfile() {
    const location = useLocation()
    const navigate = useNavigate()
    const {translate} = useApp()

    const order: IOrder = location.state?.order;
    const customer = order?.customer;

    if (!customer) {
        navigate(-1)
        return null;
    }

    return (
        <Grid2 container flexDirection={'column'} gap={2} padding={2}>
            <Grid2 container justifyContent={'space-between'} alignItems={'center'}>
                <Grid2>
                    <Typography variant='h5' fontWeight={'bold'}>
                        {translate("Customer Profile")}
                    </Typography>
                </Grid2>
                <Grid2>
                    <IconButton onClick={() => navigate('/system/orders/manage?order_id=' + order.order_id)}>
                        <Close />
                    </IconButton>
                </Grid2>
            </Grid2>
            <Container container size={'auto'} flexDirection={'column'} gap={2} padding={2}>
                <Grid2 display={'flex'} justifyContent={'center'}>
                    {customer.avatar_url ? <img src={customer.avatar_url} style={{ width: 100, height: 100, borderRadius: 100 }} /> :
                        <Avatar sx={{ width: 100, height: 100 }} />
                    }
                </Grid2>
                <Grid2 container flexDirection={'column'} gap={2}>
                    <Grid2>
                        <TextField label={translate('Name')} size="small" value={customer.name} fullWidth slotProps={{ input: { readOnly: true } }} />
                    </Grid2>
                    <Grid2>
                        <TextField label={translate('Email')} size="small" value={customer.email} fullWidth slotProps={{ input: { readOnly: true } }} />
                    </Grid2>
                </Grid2>
            </Container>
        </Grid2>
    )
}